<!-- Start Page Title Area -->
<div class="page-title-area page-title-bg1">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <h2>Partner</h2>
                    <ul>
                        <li><a routerLink="/" itemprop="url" title="EWNS, Custom Ecommerce Platform to meet all your digital needs">Home</a></li>
                        <li>Partner</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="shape-img2"><img src="assets/img/shape/shape2.svg" alt="image"></div>
    <div class="shape-img3"><img src="assets/img/shape/shape3.svg" alt="image"></div>
    <div class="shape-img4"><img src="assets/img/shape/shape4.png" alt="image"></div>
    <div class="shape-img5"><img src="assets/img/shape/shape5.png" alt="image"></div>
    <div class="shape-img7"><img src="assets/img/shape/shape7.png" alt="image"></div>
    <div class="shape-img8"><img src="assets/img/shape/shape8.png" alt="image"></div>
    <div class="shape-img9"><img src="assets/img/shape/shape9.png" alt="image"></div>
    <div class="shape-img10"><img src="assets/img/shape/shape10.png" alt="image"></div>
</div>
<!-- End Page Title Area -->


<!-- Start Partner Area -->

<section class="project-details-area ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="why-choose-content">
                    <span class="sub-title">Be a Partner</span>
                    <h2>EWNS Partner Program</h2>
                    <p>We provide our Partners a fully customizable, feature packed & hyper local SEO optimized websites, that would enable you to generate more business not just to our customers but for you, our partners as well.</p>

                    <div class="features-text">
                        <h4><i class="flaticon-tick"></i> Support</h4>
                        <p>With our solid support system, we will help you in setting up and managing your clients using our platform easily. Overcome project barriers, work directly with our team to meet your clients' specific needs. </p>
                    </div>

                    <div class="features-text">
                        <h4><i class="flaticon-tick"></i> Custom Branding</h4>
                        <p>Create a branded experience from the first client touchpoint to handover. Remove EWNS ads and keep your brand consistent by adding your logo to your dashboard and in-progress work.</p>
                    </div>

                    <div class="features-text">
                        <h4><i class="flaticon-tick"></i>Training</h4>
                        <p>Partnership with us comes with a complete training program that will ensure you know the product as well as we do, so that you can explain and pitch it better to your clients, depending on their needs.</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="why-choose-image">
                    <img src="assets/img/partners.jpeg" alt="Be a Partner">
                </div>
            </div>
        </div>
        <br/><br/><br/>
        <div class="row">
            <div class="section-title">
                <span class="sub-title">Reach Us</span>
                <h2>Fill in your basic details</h2>
            </div>
            <div class="contact-form">
                <form [formGroup]="partnerForm" (ngSubmit)="partner()">
                    <div class="row">
                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input formControlName="name" type="text" class="form-control" placeholder="Business Name">
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input formControlName="email" type="email" class="form-control" placeholder="Email">
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input formControlName="telephone" type="text" class="form-control" placeholder="Phone">
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input type="text" name="msg_subject" formControlName="website" class="form-control" placeholder="Website">
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input formControlName="city" type="text" class="form-control" placeholder="City">
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input type="text" name="msg_subject" formControlName="expertise" class="form-control" placeholder="Expertise">
                            </div>
                        </div>

   

                        <div class="col-lg-12 col-md-12">
                            <button type="submit" class="default-btn">Send Message <span></span></button>
                        </div>
                    </div>
                </form>
            </div>
           
        </div>
    </div>
</section>
<!-- End Partner Area -->